"use client";

import React, { useEffect, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface Metric {
  id: number;
  end: number;
  suffix: string;
  label: string;
}
const metrics: Metric[] = [{
  id: 1,
  end: 100,
  suffix: "%",
  label: "AU Standard Compliant"
}, {
  id: 2,
  end: 24,
  suffix: "hr",
  label: "Processing Speed"
}, {
  id: 3,
  end: 50,
  suffix: "+",
  label: "Material Categories"
}, {
  id: 4,
  end: 1200,
  suffix: "+",
  label: "Wholesale Partners"
}];
function Counter({
  end,
  suffix,
  isVisible
}: {
  end: number;
  suffix: string;
  isVisible: boolean;
}) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!isVisible) return;
    let start = 0;
    const duration = 2000;
    const frameRate = 1000 / 60;
    const totalFrames = Math.round(duration / frameRate);
    const increment = end / totalFrames;
    let currentFrame = 0;
    const timer = setInterval(() => {
      currentFrame++;
      start += increment;
      if (currentFrame >= totalFrames) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, frameRate);
    return () => clearInterval(timer);
  }, [end, isVisible]);
  return <span>
      {count}
      {suffix}
    </span>;
}
export default function GlobalManufacturingImpact() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2,
    once: true
  });
  return <section data-section-id="146978" id="b2b-supply-metrics" className="dark bg-background text-foreground py-24 px-6 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div ref={ref} className={`bg-card border-b-4 border-primary rounded-sm shadow-xl transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="grid grid-cols-1 md:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-border/40">
            {metrics.map((metric, i) => <div key={metric.id} data-index={i} className="flex flex-col items-center justify-center p-10 text-center">
                <h2 className="text-6xl md:text-7xl font-bold text-primary mb-3 tracking-tighter font-serif">
                  <Counter end={metric.end} suffix={metric.suffix} isVisible={isVisible} />
                </h2>
                <p className="text-xs md:text-sm font-medium uppercase tracking-widest text-muted-foreground font-mono">
                  {metric.label}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}